/**
 * ヘッダーの検索窓
 */

import $ from 'jquery'
import {
  $window,
  $body,
  $header
} from './globals.js'

let $input = $header.find('.c-search-bar__input');
let $searchBtn = $header.find('.c-search-bar__button');

let isSearchingClass = 'is-searching';
let coverId = 'c-cover';

// クリック
$searchBtn.on('click', function(e){
  // 画面幅がPCサイズなら何もしない
  if ($window.width() > 768) {
    return;
  }
  // 検索モードではないなら検索モードに
  if (!$header.hasClass(isSearchingClass)) {
    // submit 停止
    e.preventDefault();
    // header を検索モードに
    $header.addClass(isSearchingClass);
    // カバー追加
    $body.append('<div id="' + coverId + '" style="background: rgba(0,0,0,0.5); width: 100vw; height: 100vh; transition: 3s; position: fixed; z-index: 1000; top: 0; left: 0;"></div>');
    // フォーカス
    $input.focus();
  }
});

// フォーカスアウト
$input.on('blur', function(e){
  // 検索ボタンクリック時には実行しない
  if ($(e.relatedTarget).is($searchBtn))
    return;
  // カバー削除
  $('#' + coverId).remove();
  // クラス削除
  $header.removeClass(isSearchingClass);
});
